import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'


// $(document).scroll(function () {
//   let scroH = $(document).scrollTop(); //滚动高度
//   let viewH = $(window).height(); //可见高度
//   let mapTop = $('.item-map').offset().top; //内容高度

//   if (scroH > mapTop - viewH) {
//     $('.item-map .line-list').addClass('active')
//   }else{
//     $('.item-map .line-list').removeClass('active')
//   }
// });